module.exports = __webpack_public_path__ + "static/media/Dr image.6454f407.jpg";